export const level =
{
    moves: 20,
    field: [
        [
            "-",
            "-",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "-",
            "-"
        ],
        [
            "-",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "-"
        ],
        [
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+"
        ],
        [
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+"
        ],
        [
            "+",
            "+",
            "+",
            "-",
            "-",
            "-",
            "-",
            "+",
            "+",
            "+"
        ],
        [
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+"
        ],
        [
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+"
        ],
        [
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+"
        ],
        [
            "-",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "-"
        ],
        [
            "-",
            "-",
            "+",
            "+",
            "+",
            "+",
            "+",
            "+",
            "-",
            "-"
        ]
    ],
    objects: [
        {
            "position": {
                "x": 7,
                "y": 9
            },
            "type": 5
        },
        {
            "position": {
                "x": 6,
                "y": 9
            },
            "type": 5
        },
        {
            "position": {
                "x": 5,
                "y": 9
            },
            "type": 5
        },
        {
            "position": {
                "x": 4,
                "y": 9
            },
            "type": 5
        },
        {
            "position": {
                "x": 3,
                "y": 9
            },
            "type": 5
        },
        {
            "position": {
                "x": 2,
                "y": 9
            },
            "type": 5
        },
        {
            "position": {
                "x": 1,
                "y": 8
            },
            "type": 5
        },
        {
            "position": {
                "x": 2,
                "y": 8
            },
            "type": 5
        },
        {
            "position": {
                "x": 3,
                "y": 8
            },
            "type": 5
        },
        {
            "position": {
                "x": 4,
                "y": 8
            },
            "type": 5
        },
        {
            "position": {
                "x": 5,
                "y": 8
            },
            "type": 5
        },
        {
            "position": {
                "x": 6,
                "y": 8
            },
            "type": 5
        },
        {
            "position": {
                "x": 7,
                "y": 8
            },
            "type": 5
        },
        {
            "position": {
                "x": 8,
                "y": 8
            },
            "type": 5
        },
        {
            "position": {
                "x": 9,
                "y": 7
            },
            "type": 5
        },
        {
            "position": {
                "x": 8,
                "y": 7
            },
            "type": 5
        },
        {
            "position": {
                "x": 7,
                "y": 7
            },
            "type": 5
        },
        {
            "position": {
                "x": 6,
                "y": 7
            },
            "type": 5
        },
        {
            "position": {
                "x": 5,
                "y": 7
            },
            "type": 5
        },
        {
            "position": {
                "x": 4,
                "y": 7
            },
            "type": 5
        },
        {
            "position": {
                "x": 3,
                "y": 7
            },
            "type": 5
        },
        {
            "position": {
                "x": 2,
                "y": 7
            },
            "type": 5
        },
        {
            "position": {
                "x": 1,
                "y": 7
            },
            "type": 5
        },
        {
            "position": {
                "x": 0,
                "y": 7
            },
            "type": 5
        },
        {
            "position": {
                "x": 1,
                "y": 4
            },
            "type": 13
        }
    ]
}